import React, { useState } from 'react';
import { RECORDS } from '../../constants/columns';
import { useTable, useGlobalFilter, usePagination, useSortBy } from 'react-table';
import { equipmentOptions } from '../../constants/filterOptions';
import { useNavigate } from 'react-router-dom';
import axios from '../../plugins/axios';

// components
import Header from '../../components/Header/Header';
import Table from '../../components/Table/Table';
import TableTabs from '../../components/TableTabs/TableTabs';
import Empty from '../../components/Empty/Empty';

// icons
import icon from '../../brand/generated/sidebar/records.svg';
import eye from '../../brand/generated/popover/eye.svg';
import bucket from '../../brand/generated/popover/delete.svg';
import edit from '../../brand/generated/popover/edit.svg';
import x from '../../brand/generated/popover/x.svg';
import accept from '../../brand/generated/popover/accept.svg';

const tableStyle = { backgroundColor: 'white' };

const popoverActions = [
  { title: 'ÐÑÐ¾ÑÐ¼Ð¾ÑÑÐµÑÑ Ð·Ð°Ð¿Ð¸ÑÑ', icon: eye },
  { title: 'Ð ÐµÐ´Ð°ÐºÑÐ¸ÑÐ¾Ð²Ð°ÑÑ Ð·Ð°Ð¿Ð¸ÑÑ', icon: edit },
  { title: 'ÐÐ¾Ð´ÑÐ²ÐµÑÐ´Ð¸ÑÑ Ð·Ð°Ð¿Ð¸ÑÑ', icon: accept },
  { title: 'ÐÑÐ¼ÐµÐ½Ð¸ÑÑ Ð·Ð°Ð¿Ð¸ÑÑ', icon: x },
  { title: 'Ð£Ð´Ð°Ð»Ð¸ÑÑ Ð·Ð°Ð¿Ð¸ÑÑ', icon: bucket },
];

const Records = () => {
  const [columns, setColumns] = useState(RECORDS);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [popover, setPopover] = useState(popoverActions);
  const [records, setRecords] = useState([]);
  const [dataCount, setDataCount] = useState(0);
  const [pagination, setPagination] = useState({
    page: 1,
    totalPages: 1,
    hasPreviousPage: false,
    hasNextPage: false,
    pageSize: 10,
  });
  const [isFetchAll, setFetchAll] = useState(false);

  const table = useTable(
    {
      columns,
      data: records,
      initialState: {
        pageSize: pagination.pageSize,
      },
      manualPagination: true,
      disableSortRemove: true,
      pageCount: pagination.totalPages,
      page: pagination.page - 1,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );
  const { setGlobalFilter, page, setPageSize } = table;

  const [value, setValue] = useState('');
  const [queryParams, setQueryParams] = useState({});

  const addRecord = () => {
    navigate('/records/add-record-service');
  };

  // Ð¢ÐµÑÑ-Ð´ÑÐ°Ð¹Ð² Ð¸ ÑÐµÑÐ²Ð¸Ñ Ð¾ÑÐºÑÑÐ²Ð°ÑÑÑÑ Ð¾Ð´Ð½Ð¾Ð¹ ÐºÐ°ÑÑÐ¾ÑÐºÐ¾Ð¹, Ð½Ð¾ Ð¿Ð¾ ÑÐ°Ð·Ð½ÑÐ¼ Ð°Ð´ÑÐµÑÐ°Ð¼:
  // Ð¾Ð½Ð° Ð²ÐµÑÐ²Ð¸ÑÑÑ Ð¿Ð¾ ÑÐ¸Ð¿Ñ Ð·Ð°Ð¿Ð¸ÑÐ¸, Ð¸ URL Ð´Ð¾Ð»Ð¶ÐµÐ½ Ð³Ð¾Ð²Ð¾ÑÐ¸ÑÑ, ÑÑÐ¾ Ð¸Ð¼ÐµÐ½Ð½Ð¾ Ð¾ÑÐºÑÑÑ.
  const recordPath = (record) => `/records/${record?.type?.id === 1 ? 'test-drive' : 'service'}/${record?.id}`;

  const handleActionPopover = (rowIndex, actionIndex, action) => {
    if (action === popoverActions[0].title) {
      navigate(recordPath(records[rowIndex]));
    }
  };

  const init = async (params) => {
    setLoading(true);
    await axios
      .get('/api/crm/services/getServiceRecords', { params: { ...params } })
      .then((res) => {
        setRecords(res.data.services);
        setPagination({
          ...res.data.pagination,
          page: res.data.pagination?.pageNumber,
          pageSize: pagination.pageSize,
        });
        setDataCount(res.data.pagination?.count);
      })
      .finally(() => setLoading(false));
  };

  const handleNavigate = (index) => {
    const record = records.filter((item) => item.id === index);
    navigate(recordPath(record[0]));
  };

  React.useEffect(() => {
    if (!isFetchAll) {
      init({ page: pagination.page, pageSize: pagination.pageSize, ...queryParams });
    }
  }, [pagination.page, pagination.pageSize, queryParams]);

  return (
    <>
      <Header title="ÐÐ°Ð¿Ð¸ÑÐ¸" icon={icon} />
      <br />
      <br />
      <br />
      <br />
      <TableTabs
        setFilter={setGlobalFilter}
        options={equipmentOptions}
        value={value}
        setValue={setValue}
        navigate={addRecord}
        button={'ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ð·Ð°Ð¿Ð¸ÑÑ'}
        inputPlaceholder={'ÐÑÑÑÑÑÐ¹ Ð¿Ð¾Ð¸ÑÐº Ð¿Ð¾ Ð·Ð°Ð¿Ð¸ÑÑÐ¼'}
      />
      <br />
      {!page.length && !loading ? (
        <Empty />
      ) : (
        <Table
          table={table}
          all={'Ð·Ð°Ð¿Ð¸ÑÐµÐ¹'}
          pagination
          sort
          style={tableStyle}
          popover={popover}
          popoverActions={popoverActions}
          setPopover={setPopover}
          handleActionPopover={handleActionPopover}
          setPagination={setPagination}
          setFetchAll={setFetchAll}
          isFetchAll={isFetchAll}
          setData={setRecords}
          p={pagination}
          handleNavigate={handleNavigate}
          loading={loading}
          setLoading={setLoading}
          columns={columns}
          setColumns={setColumns}
          columnsSettingsKey="records"
          queryParams={queryParams}
          api={'/api/crm/services/getServiceRecords'}
          response={'services'}
          isSortable
          dataCount={dataCount}
        />
      )}
    </>
  );
};

export default Records;
